import { useState, useEffect } from 'react';

export const useSidebar = () => {
  const [mini, setMini] = useState(() => {
    const saved = localStorage.getItem('sidebar-mini');
    return saved ? JSON.parse(saved) : false;
  });

  const [hovered, setHovered] = useState(false);

  // Persistir estado en localStorage
  useEffect(() => {
    localStorage.setItem('sidebar-mini', JSON.stringify(mini));
  }, [mini]);

  // Auto-colapso responsive
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1280) {
        setMini(true);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => setMini(!mini);

  return {
    mini,
    setMini,
    hovered,
    setHovered,
    toggleSidebar,
  };
};